import Mediasite from "../../assets/sdk/MediasitePlayerIFrameAPI";
import PlayerControls from "../../assets/sdk/MediasitePlayerControls";

const constructURL = (id) => {
  // Strip possible params from video URL
  id = id.split("?")[0];

  // Add necessary params to URL
  return `https://media.om.nl/MediaSite/Play/${id}?player=MediasiteIntegration&coverTitle=false&coverPlayButton=false`;
};

export const initPlayer = (url) => {
  const video = document.getElementById("video"),
    controlsEl = document.getElementById("controls"),
    playButton = document.getElementById("play-button"),
    closeModal = document.querySelector(".modal-close");

  let controls;

  const player = new Mediasite.Player(video.id, {
    url: constructURL(url),
    events: {
      playcoverready: function () {
        player.seekTo(0);
        // Clear classes on reInit player
        playButton.classList.remove("hide");
        playButton.classList.remove("has-played");

        createControls(player, controlsEl);
      },
      ready: function () {
        player.seekTo(0);
        player.play();
        playButton.addEventListener("click", () => {
          player.play();
        });
        closeModal.addEventListener("click", () => {
          player.stop();
        });
      },
      error: function (e) {
        console.log(
          "Error: " +
            Mediasite.ErrorDescription[e.errorCode] +
            (e.details ? "(" + e.details + ")" : "")
        );
      },
      playstatechanged: onPlayStateChanged,
    },
  });
  function onPlayStateChanged(e) {
    if (
      e.playState === "opening" ||
      e.playState === "ready" ||
      e.playState === "playing"
    ) {
      playButton.classList.add("hide");
      playButton.classList.add("has-played");
    } else {
      playButton.classList.remove("hide");
    }
  }

  function createControls(player, el) {
    controls = new window.Mediasite.PlayerControls(player, el.id, {
      imageSprite: "url(../../assets/sdk/MediasitePlayerControls.png)",
    });
  }
};
